export const flatFunnelFillPlugin = {
  id: 'flatFunnelFillPlugin',
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx
    const dataset = chart.getDatasetMeta(0)
    const points = dataset.data.map(point => point.getProps(['x', 'y'], true))

    ctx.save()
    ctx.fillStyle = 'rgba(54, 162, 235, 0.3)'
    ctx.beginPath()

    ctx.moveTo(points[0].x - (dataset.data[0].width / 2), points[0].y)

    points.forEach((point, index) => {
      ctx.lineTo(point.x + (dataset.data[index].width / 2), point.y)
      if (index < points.length - 1) {
        ctx.lineTo(points[index + 1].x - (dataset.data[index + 1].width / 2), points[index + 1].y)
      }
    })

    ctx.lineTo(points[points.length - 1].x + (dataset.data[points.length - 1].width / 2), chart.scales.y.bottom)
    ctx.lineTo(points[0].x - (dataset.data[0].width / 2), chart.scales.y.bottom)
    ctx.closePath()

    ctx.fill()
    ctx.restore()
  }
}
